import React, { useState, useEffect } from "react";

const CityDropdown = ({ 
  countryName,
  stateName,
  value, 
  onChange, 
  placeholder = "Select City",
  className = "",
  required = false,
  id = "city",
  name = "city"
}) => {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch cities when state is selected
    if (countryName && stateName) {
      fetchCities(countryName, stateName);
    } else {
      // Clear cities if state not selected
      setCities([]);
    }
  }, [countryName, stateName]);

  const fetchCities = async (country, state) => {
    try {
      setLoading(true);
      setError(null);
      
      // countriesnow now serves cities via GET /state/cities/q?country=&state=.
      // The old POST /state/cities (JSON body) 301-redirects here, and the
      // browser drops the redirected cross-origin POST -> "Failed to load cities".
      const response = await fetch(
        'https://countriesnow.space/api/v0.1/countries/state/cities/q?country=' +
          encodeURIComponent(country) + '&state=' + encodeURIComponent(state)
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch cities: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.data && Array.isArray(data.data)) {
        const formattedCities = data.data
          .map(city => ({
            name: typeof city === 'string' ? city : city.name || city
          }))
          .filter(city => city.name); // Filter out empty entries
        
        formattedCities.sort((a, b) => a.name.localeCompare(b.name));
        setCities(formattedCities);
      } else {
        setCities([]);
      }
    } catch (err) {
      console.error('Error fetching cities:', err);
      setError('Failed to load cities');
      setCities([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  if (!countryName || !stateName) {
    return (
      <select 
        className={className}
        disabled
        id={id}
        name={name}
      >
        <option>Please select country and state first</option>
      </select>
    );
  }

  if (loading) {
    return (
      <select 
        className={className}
        disabled
        id={id}
        name={name}
      >
        <option>Loading cities...</option>
      </select>
    );
  }

  if (error) {
    return (
      <select 
        className={className}
        disabled
        id={id}
        name={name}
      >
        <option>Error loading cities</option>
      </select>
    );
  }

  if (cities.length === 0) {
    return (
      <select 
        className={className}
        id={id}
        name={name}
        value={value}
        onChange={handleChange}
        required={required}
      >
        <option value="">No cities available</option>
      </select>
    );
  }

  return (
    <select
      id={id}
      name={name}
      value={value}
      onChange={handleChange}
      className={className}
      required={required}
      style={{ 
        height: '36px',
        padding: '0 8px',
        lineHeight: '36px'
      }}
    >
      {placeholder && !value && (
        <option value="">
          {placeholder}
        </option>
      )}
      {cities.map((city, index) => (
        <option key={index} value={city.name} style={{ padding: '10px 8px', lineHeight: '1.5' }}>
          {city.name}
        </option>
      ))}
    </select>
  );
};

export default CityDropdown;
